<ng-container formGroupName="precedingCropSettings">
  <div class="flex__child--auto">
    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'crop' | translate }}
      </mat-label>
      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        [matAutocomplete]="cropAutocomplete"
        #newCropInput
        data-test="preceding-crop-settings-crop-id"
        formControlName="cropId"
        (blur)="checkCrop()"
      />
      <mat-autocomplete
        #cropAutocomplete="matAutocomplete"
        (optionSelected)="selectCrop($event.option.value)"
        [displayWith]="displayCrop()"
      >
        @for (crop of filteredCrops$ | async; track crop) {
          <mat-option [value]="crop.id" data-test="preceding-crop-settings-crop-option">
            {{ crop.agrifirmCrop.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="flex__child--auto">
    <div class="mat-slide-group-wrapper">
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="isNitrogenDeliveryAmountSetManually"
          data-test="preceding-crop-settings-is-nitrogen-delivery-manually"
          >{{ 'nitrogenDeliveryAmountSetManually' | translate }}</mat-slide-toggle
        >
      </div>
    </div>

    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'nitrogenDeliveryAmount' | translate }}
      </mat-label>
      <input
        matInput
        agrNumber
        maxlength="7"
        [placeholder]="'nitrogenDeliveryAmount' | translate"
        formControlName="nitrogenDeliveryAmount"
        data-test="preceding-crop-settings-nitrogen-delivery-amount"
        [step]="1"
        autocomplete="off"
      />
    </mat-form-field>
  </div>
</ng-container>
